<div class="astrea-box astrea-cart-physical mb-3">

    <div class="astrea-cart-title">
        <h3 class="mb-2">
            {{ 'cart.physical.title' | translate }}
        </h3>
        <p>
            <strong>{{ 'cart.total' | translate }}: </strong>{{ pricingService.getCurrency() }}{{ (shipmentService.getShipmentAndTotal(totalPhysical) | async) }}
        </p>
    </div>

    <div class="astrea-cart-msg d-flex flex-column mt-3">
        <div>
            <div>
                <h5>{{ 'cart.physical.text4' | translate }}:</h5>
            </div>
            <ul>
                <li *ngFor="let b of books">
                    {{ b.bookInfo.title }} <small>(x{{ b.cartInfo.count }})</small>
                </li>
            </ul>
        </div>
    </div>

    <hr>

    <mat-accordion class="w-100">

        <!-- ********** PASO 1 ********** -->
        <mat-expansion-panel [expanded]="step == 0" (opened)="nextStep(0)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <strong>
                        {{ 'cart.steps.step' | translate }} 1: {{ 'cart.steps.invoicing_destiny' | translate }}
                        <small class="step-ok">
                            <i *ngIf="userInvoicing && userResidence">- ({{ 'cart.steps.thanks' | translate }})</i>
                        </small>
                    </strong>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="grid-50-50">
                <div class="form-invoicing">
                    <astrea-profile-invoicing
                        [setUser]="user"
                        [isTouch]="isTouch"
                    ></astrea-profile-invoicing>
                </div>
                <div class="form-residence">
                    <astrea-profile-residence
                        [setUser]="user"
                        [isTouch]="isTouch"
                    ></astrea-profile-residence>
                </div>
            </div>

            <div *ngIf="userInvoicing && userResidence">
                <div class="t-center p-3">
                    <button (click)="nextStep(1)" class="btn btn-next-step mt-2" mat-button>
                        {{ 'cart.continue_payment' | translate }}
                    </button>
                </div>
            </div>

        </mat-expansion-panel>

        <!-- ********** PASO 2 ********** -->
        <mat-expansion-panel (click)="stepShipmentMethod()" (opened)="nextStep(1)" [expanded]="step == 1" [disabled]="!userInvoicing || !userResidence" [ngClass]="(userInvoicing && userResidence) ? '' : 'disabled-step'">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <strong>
                        {{ 'cart.steps.step' | translate }} 2: {{ 'cart.steps.shipment' | translate }}
                        <small class="step-ok">
                            <i *ngIf="shipmentMethod">{{ shipmentMethod == 'house' ? '- (' + ('history.purchases.house' | translate) + ')' : shipmentMethod == 'correo-argentino' ? '- (Andreani)' : shipmentMethod == 'dhl' ? '- (DHL)' : '' }}</i>
                        </small>
                    </strong>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="cart-cards-wrapper p-3">
                <button *ngIf="user && user.nationality == 'AR'" (click)="setShipmentMethod('house')" class="btn-method h-responsive" [ngClass]="shipmentMethod == 'house' ? 'method-active' : ''">
                    <img src="/assets/images/astrea-brand/astrea-name.png" alt="Editorial Astrea">
                    <span>{{ 'cart.physical.house' | translate }}</span>
                </button>
                <button *ngIf="user && user.nationality == 'AR'" (click)="setShipmentMethod('correo-argentino')" class="btn-method h-responsive" [ngClass]="shipmentMethod == 'correo-argentino' ? 'method-active' : ''">
                    <img src="/assets/images/cart/andreani.png" alt="Logo Andreani">
                    <span>{{ 'cart.mp.shipment' | translate }}</span>
                </button>
                <button *ngIf="user && user.nationality != 'AR'" (click)="setShipmentMethod('dhl')"class="btn-method h-responsive" [ngClass]="shipmentMethod == 'dhl' ? 'method-active' : ''">
                    <img class="mt-2" src="/assets/images/cart/logo_dhl.svg" alt="Logo DHL">
                    <span>{{ 'cart.pp.shipment' | translate }}</span>
                </button>
            </div>

            <div>
                <div class="t-center p-3">
                    <p *ngIf="shipmentMethod == 'house'" class="t-center">
                        {{ 'cart.cash.text5' | translate }} <strong><a href="https://g.page/EditorialAstrea?share" target="_blank" title="Ubicación Editorial Astrea">Lavalle 1208 (C1048AAF) - CABA</a></strong> {{ 'cart.cash.text2' | translate }}
                        <br>
                        <i>
                            <strong>{{ 'cart.physical.shipment' | translate }}:</strong> {{ 'cart.physical.no_fee' | translate }} | <strong>{{ 'cart.physical.book' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }} | <strong>{{ 'cart.total' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }}
                        </i>
                    </p>
                    <p *ngIf="shipmentMethod == 'correo-argentino'" class="t-center">
                        {{ 'purchases.success.text_3' | translate }} <strong>{{ user.addressResidence }} ({{ user.postalCodeResidence }}) - {{ user.cityResidence }}</strong> {{ 'purchases.success.correo_argentino' | translate }}
                        <br>
                        <i>
                            <strong>{{ 'cart.physical.shipment' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipment(totalPhysical) | async) }} | <strong>{{ 'cart.physical.book' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }} | <strong>{{ 'cart.total' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipmentAndTotal(totalPhysical) | async) }}
                        </i>
                    </p>
                    <p *ngIf="shipmentMethod == 'dhl'" class="t-center">
                        {{ 'purchases.success.text_3' | translate }} <strong>{{ user.addressResidence }} ({{ user.postalCodeResidence }}) - {{ user.cityResidence }}, {{ getCountry(user && user.nationality) }}</strong> {{ 'purchases.success.dhl2' | translate }}
                        <br>
                        <i>
                            <strong>{{ 'cart.physical.shipment' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipment(totalPhysical) | async) }} | <strong>{{ 'cart.physical.book' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }} | <strong>{{ 'cart.total' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipmentAndTotal(totalPhysical) | async) }}
                        </i>
                    </p>
                    <button *ngIf="shipmentMethod" (click)="nextStep(2)" class="btn btn-next-step mt-2" mat-button>
                        {{ 'cart.continue_payment' | translate }}
                    </button>
                </div>
            </div>

        </mat-expansion-panel>

        <!-- ********** PASO 3 ********** -->
        <mat-expansion-panel (click)="stepPaidMethod()" (opened)="nextStep(2)" [expanded]="step == 2" [disabled]="!shipmentMethod" [ngClass]="(shipmentMethod) ? '' : 'disabled-step'">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <strong>
                        {{ 'cart.steps.step' | translate }} 3: {{ 'cart.steps.payment' | translate }}
                        <small class="step-ok">
                            <i *ngIf="payMethod">{{ payMethod == 'mercado-pago' ? '- (Mercado Pago)' : payMethod == 'paypal' ? '- (PayPal)' : payMethod == 'cash' ? '- (Efectivo)' : '' }}</i>
                        </small>
                    </strong>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="cart-cards-wrapper p-3">
                <button *ngIf="user && user.nationality == 'AR'" (click)="setPayMethod('mercado-pago')" class="btn-method h-responsive" [ngClass]="payMethod == 'mercado-pago' ? 'method-active' : ''">
                    <img src="/assets/images/cart/mp.svg" alt="Logo Mercado Pago">
                    <span>{{ 'cart.mp.title' | translate }}</span>
                </button>
                <button *ngIf="user && user.nationality != 'AR'" (click)="setPayMethod('paypal')" class="btn-method h-responsive" [ngClass]="payMethod == 'paypal' ? 'method-active' : ''">
                    <img src="/assets/images/cart/paypal.svg" alt="Logo PayPal">
                    <span>{{ 'cart.pp.title' | translate }}</span>
                </button>
                <!-- <button *ngIf="user && user.nationality == 'AR'" (click)="setPayMethod('cash')" class="btn-method h-responsive" [ngClass]="payMethod == 'cash' ? 'method-active' : ''">
                    <img src="/assets/images/cart/cash.png" alt="Pago en efectivo">
                    <span>{{ 'cart.cash.cash' | translate }}</span>
                </button> -->
            </div>

            <div *ngIf="shipmentMethod && payMethod">
                <div class="t-center p-3">

                    <!-- Cash & Mercado Pago -->
                    <p *ngIf="payMethod == 'cash'" class="t-center">
                        <span *ngIf="shipmentMethod == 'house'">
                            {{ 'cart.cash.text1' | translate }} <strong><a href="https://g.page/EditorialAstrea?share" target="_blank" title="Ubicación Editorial Astrea">Lavalle 1208 (C1048AAF) - CABA</a></strong> {{ 'cart.cash.text2' | translate }}
                            <br>
                            <i>
                                <strong>{{ 'cart.physical.shipment' | translate }}:</strong> {{ 'cart.physical.no_fee' | translate }} | <strong>{{ 'cart.physical.book' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }} | <strong>{{ 'cart.total' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }}
                            </i>
                        </span>
                        <span *ngIf="shipmentMethod == 'correo-argentino'">
                            {{ 'cart.cash.text3' | translate }}<br>
                            {{ 'cart.cash.text4' | translate }} <strong>{{ user.addressResidence }} ({{ user.postalCodeResidence }}) - {{ user.cityResidence }}, {{ getCountry(user && user.nationality) }}</strong>.
                            <br>
                            <i>
                                <strong>{{ 'cart.physical.shipment' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipment(totalPhysical) | async) }} | <strong>{{ 'cart.physical.book' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }} | <strong>{{ 'cart.total' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipmentAndTotal(totalPhysical) | async) }}
                            </i>
                        </span>
                    </p>
                    <p *ngIf="payMethod == 'mercado-pago'" class="t-center">
                        {{ 'cart.mp.text1' | translate }}<br>
                        <span *ngIf="shipmentMethod == 'house'">
                            {{ 'purchases.success.text_1' | translate }} <strong><a href="https://g.page/EditorialAstrea?share" target="_blank" title="Ubicación Editorial Astrea">Lavalle 1208 (C1048AAF) - CABA</a></strong> {{ 'purchases.success.text_2' | translate }}
                            <br>
                            <i>
                                <strong>{{ 'cart.physical.shipment' | translate }}:</strong> {{ 'cart.physical.no_fee' | translate }} | <strong>{{ 'cart.physical.book' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }} | <strong>{{ 'cart.total' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }}
                            </i>
                        </span>
                        <span *ngIf="shipmentMethod == 'correo-argentino'">
                            {{ 'cart.cash.text4' | translate }} <strong>{{ user.addressResidence }} ({{ user.postalCodeResidence }}) - {{ user.cityResidence }}, {{ getCountry(user && user.nationality) }}</strong>.
                            <br>
                            <i>
                                <strong>{{ 'cart.physical.shipment' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipment(totalPhysical) | async) }} | <strong>{{ 'cart.physical.book' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }} | <strong>{{ 'cart.total' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipmentAndTotal(totalPhysical) | async) }}
                            </i>
                        </span>
                    </p>
                    <button *ngIf="!preparingPaid && (payMethod == 'cash' || payMethod == 'mercado-pago')" (click)="confirmPay()" class="btn btn-next-step mt-3" mat-button>
                        {{ 'cart.pay' | translate }}
                    </button>
                    <button *ngIf="preparingPaid && (payMethod == 'cash' || payMethod == 'mercado-pago')" class="btn btn-next-step mt-3" mat-button>
                        <astrea-loading></astrea-loading>
                    </button>

                    <!-- PayPal -->
                    <p *ngIf="payMethod == 'paypal'" class="t-center">
                        {{ 'cart.pp.text1' | translate }}<br>
                        <i>
                            <strong>{{ 'cart.physical.shipment' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipment(totalPhysical) | async) }} | <strong>{{ 'cart.physical.book' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ totalPhysical }} | <strong>{{ 'cart.total' | translate }}:</strong> {{ pricingService.getCurrency() }}{{ (shipmentService.getShipmentAndTotal(totalPhysical) | async) }}
                        </i>
                    </p>
                    <astrea-loading *ngIf="paypalLoading" class="mt-3" text="{{ 'cart.pp.loading' | translate }}"></astrea-loading>
                    <ngx-paypal
                        *ngIf="payMethod == 'paypal'"
                        class="mt-3"
                        [config]="payPalConfig"
                    ></ngx-paypal>

                </div>
            </div>

        </mat-expansion-panel>

    </mat-accordion>

</div>
